import PropTypes from 'prop-types';
import React from 'react';
import Dropdown from 'react-bootstrap/es/Dropdown';
import DropdownMenu from 'react-bootstrap/es/DropdownMenu';
import cx from 'classnames';
import { showDeprecatedWarning } from "../utils/warnings";
import DropdownToggle from "./dropdown-toggle";

var DropdownButton = function DropdownButton(_ref) {
  var id = _ref.id,
      dropup = _ref.dropup,
      disabled = _ref.disabled,
      pullRight = _ref.pullRight,
      open = _ref.open,
      onToggle = _ref.onToggle,
      onSelect = _ref.onSelect,
      bsSize = _ref.bsSize,
      bsStyle = _ref.bsStyle,
      title = _ref.title,
      children = _ref.children,
      withCaret = _ref.withCaret,
      className = _ref.className;
  showDeprecatedWarning('DropdownButton', 'Dropdown');
  return React.createElement("div", {
    className: cx('DropdownButton', className)
  }, React.createElement(Dropdown, {
    id: id,
    dropup: dropup,
    disabled: disabled,
    pullRight: pullRight,
    open: open,
    onToggle: onToggle,
    onSelect: onSelect,
    bsSize: bsSize,
    bsStyle: bsStyle
  }, React.createElement(DropdownToggle, {
    bsRole: "toggle",
    bsClass: "btn",
    bsSize: bsSize,
    bsStyle: bsStyle,
    withCaret: withCaret
  }, title), React.createElement(DropdownMenu, null, children)));
};

DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = {
  id: PropTypes.string,
  dropup: PropTypes.bool,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  pullRight: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  onSelect: PropTypes.func,
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  title: PropTypes.node.isRequired,
  withCaret: PropTypes.bool,
  className: PropTypes.string
};
DropdownButton.defaultProps = {
  withCaret: true
};
export default DropdownButton;